import Api from "./baseApi";
export default {
  searchProduct: product => {
    let url = "/api/products?v=1";
    if (product.search) url += `&q=${product.search}`;
    if (product.state > -1) url += `&state=${product.state}`;
    if (product.categoryId > 0) url += `&categoryId=${product.categoryId}`;
    return Api.get(url);
  },
  getProducts: () => Api.get("/api/products"),
  getProductsByMpProducts: () => Api.get("/api/products/mp"),
  getProduct: id => Api.get(`/api/products/${id}`),
  putProduct: product => {
    console.log("API putProduct çağrıldı:", product);
    console.log("PUT URL:", `/api/products/${product.id}`);
    return Api.put(`/api/products/${product.id}`, product);
  },
  deleteProduct: product => Api.delete(`/api/products/${product.id}`, product),
  postProduct: product => Api.post(`/api/products`, product),
  buyProducts(products, cb, errorCb) {
    setTimeout(() => {
      // simulate random checkout failure.
      Math.random() > 0.5 || navigator.userAgent.indexOf("PhantomJS") > -1
        ? cb()
        : errorCb();
    }, 100);
  },
  getBestSellers: () => Api.get("/api/products/bestsellers"),
  getAvailableProductsForBestSeller: (q = null) => {
    let url = "/api/products/bestsellers/available";
    if (q) url += `?q=${q}`;
    return Api.get(url);
  },
  addToBestSellers: productIds => Api.post("/api/products/bestsellers/add", productIds),
  removeFromBestSeller: productId => Api.post(`/api/products/bestsellers/remove/${productId}`),
  updateBestSellerOrder: productIds => Api.put("/api/products/bestsellers/reorder", productIds)
};
